import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { AdvanceList, AdvanceListItem } from '../../components/AdvanceList';
import * as analytics from 'shared/lib/analytics';
import './ClaimsInStoreRepair.css';


class ClaimsInStoreRepair extends Component {

  componentDidMount() {
    document.title = `Claims | Repair in store - Sure`;
    analytics.page('Portal - Claim Bring In For Repair', {
      category: 'claim',
    });
  }

  trackFindAStoreClick() {
    analytics.track('Portal - Claim Find a Store Clicked', {
      category: 'claim',
      label: 'https://www.apple.com/retail/',
    });
  }

  trackAlreadyRepairedClick() {
    analytics.track('Portal - Claim Phone Already Repaired Clicked', { category: 'claim' });
  }

  render() {
    const { verticalCode, policyNumber } = this.props.params;
    const damagesLink = `/account/claims/new/${verticalCode}/policies/${policyNumber}/damages`;
    return (
      <div className="ClaimsInStoreRepair">
        <div className="Container Container--small">
          <h1 className="ClaimsInStoreRepair-heading">
            Submit your claim after your device has been repaired at an Apple Store
          </h1>
          <AdvanceList>
            <AdvanceListItem
              linkTo="https://www.apple.com/retail/"
              title="Find a store"
              external={!this.props.isEmbed}
              onClick={this.trackFindAStoreClick}
            />
            <AdvanceListItem
              linkTo={damagesLink}
              title="My phone has already been repaired by Apple"
              onClick={this.trackAlreadyRepairedClick}
            />
          </AdvanceList>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isEmbed: state.isEmbed,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps, mapDispatchToProps
)(withRouter(ClaimsInStoreRepair));
